// Core
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// logo
import Logo from 'assets/images/logo.png'

// Styles
import './styles.scss';
import { Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const Header = () => {
  const { userDetails, currentLang } = useSelector((store) => store.commonData);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    i18n.changeLanguage(currentLang.lang);
    if (currentLang.lang === 'ar') {
      document.body.classList.add('arabic');
    }
    else {
      document.body.classList.remove('arabic')
    }
  }, []);

  const handleClose = (value) => {
    setAnchorEl(null);
    if (value) {
      dispatch({
        type: 'currentLang',
        value: { lang: value, id: value === 'ar' ? 1 : 2 }
      });
      i18n.changeLanguage(value);
      if (value === 'ar') {
        document.body.classList.add('arabic');
      }
      else {
        document.body.classList.remove('arabic')
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };


  return (
    <div className='__header'>
      <img src={Logo} alt="sheikhaart" />
      <div className=' __menus' >
        <NavLink to={'/'} end>{t('home')}</NavLink>
        <NavLink to={'about'} end>{t('about')}</NavLink>
        <NavLink to={'portfolio'} end>{t('portfolio')}</NavLink>
        <NavLink to={'contact'} end>{t('contact')}</NavLink>
      </div>
      <div className='__lang_mn'>
        <button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className='lang_btn'
        >
           <LanguageIcon style={{margin:'0 10px'}}/>{currentLang?.lang === 'ar' ? 'العربي' : 'ENG'}
        </button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClick={() => handleClose('')}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => handleClose('ar')} style={{ minWidth: '100px' }}>العربي</MenuItem>
          <MenuItem onClick={() => handleClose('en')} style={{ minWidth: '100px' }}>ENG</MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
